import { TasksWebComponent } from './component/TasksWebComponent';
import { WEB_COMPONENT_NETWORK_TASKS } from '../../webcomponents.constants';
/**
 * Page component for displaying Tasks page
 * @link https://bitdefender.atlassian.net/wiki/spaces/GZDOCS/pages/1153468358/Tasks+Page
 */
export { TasksWebComponent };

window.customElements.define(WEB_COMPONENT_NETWORK_TASKS, TasksWebComponent);
